/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formattachment_Note1Inputs */

const ja_contact_formattachment_note1 = /** @type {(inputs: Contact_Formattachment_Note1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`職務経歴書、履歴書、ポートフォリオなどのファイルはこちらにアップロードしてください。最大2つのファイルを追加できます。それぞれのファイルは2MB以内に収めてください。`)
};

const en_contact_formattachment_note1 = /** @type {(inputs: Contact_Formattachment_Note1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can attach up to 2 files. Each file should be no more than 2mb.`)
};

/**
* | output |
* | --- |
* | "You can attach up to 2 files. Each file should be no more than 2mb." |
*
* @param {Contact_Formattachment_Note1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formattachment_note1 = /** @type {((inputs?: Contact_Formattachment_Note1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formattachment_Note1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formattachment_note1(inputs)
	return en_contact_formattachment_note1(inputs)
});
export { contact_formattachment_note1 as "contact_formAttachment_note" }